import React from 'react';
import PropTypes from 'prop-types';

const DESCSortIcon = ({ handleClick, size = '1rem' }) => {
    return (
        <svg
            onClick={handleClick}
            style={{ cursor: 'pointer' }}
            fill='#000000'
            width={size}
            height={size}
            viewBox='0 0 14 14'
            role='img'
            focusable='false'
            aria-hidden='true'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='red'
                d='M11.268 12.053H9.595L9.247 13H8.142l1.8-4.8h.916l1.768 4.8h-1.01zM9.816 11.2h1.2l-.6-1.8zm.063-6.19h2.4v.79H8.616v-.6l2.4-3.41h-2.4V1h3.6v.537z'
            />
            <path fill='red' d='M2.7 1v8.842H.805L3.332 13l2.526-3.158H3.963V1z' />
        </svg>
    );
};

DESCSortIcon.propTypes = {
    handleClick: PropTypes.func,
};

export default DESCSortIcon;
